import type {SafeHTMLString} from '@github-ui/safe-html'
import {setSanitizedInnerHTML} from '@github-ui/sanitize/set-inner-html'

type PullRequestLink = {
  url: string
  owner: string
  repository: string
  number: number
} & ({title: string; titleHtml?: never} | {title?: never; titleHtml: SafeHTMLString})

export function buildPullRequestLink({url, owner, repository, number, title, titleHtml}: PullRequestLink) {
  const link = document.createElement('a')
  link.href = url
  if (titleHtml !== undefined) {
    setSanitizedInnerHTML(link, titleHtml)
  } else {
    link.textContent = title
  }
  link.append(` (${owner}/${repository}#${number})`)

  return link
}
